import * as Yup from 'yup';

export const FirmStrategyCreateUpdateFundFormValidationSchema = Yup.object().shape(
  {
    FundName: Yup.string()
      .max(100, 'You have exceeded the maximum number of 100 characters')
      .required('This field is required'),

    FundNumber: Yup.number()
      .min(0.1, 'Value must be greater than or equal to 0.1')
      .max(999.9, 'Value must be less than or equal to 999.9')
      .test(
        'validate-decimal',
        'Please enter a number that has only one digit after the decimal point',
        value => !value || (value * 10) % 1 === 0
      )
      .required('Please enter a number'),

    FundNumberType: Yup.object()
      .nullable()
      .required('This field is required'),

    Vintage: Yup.object()
      .nullable()
      .required('This field is required'),

    FirmFundFocusID: Yup.object()
      .nullable()
      .required('This field is required'),

    Geography: Yup.string()
      .max(100, 'You have exceeded the maximum number of 100 characters')
      .required('This field is required'),

    Returns: Yup.string()
      .nullable()
      .max(100, 'You have exceeded the maximum number of 100 characters'),
  }
);
